export default () => ({
  activeNav: null,
  subHovered: false,
  
  // Open megamenu
  openNav(id) {
    this.activeNav = id;
    this.subHovered = true;
  },
  
  // Close megamenu
  closeNav() {
    this.activeNav = null;
    this.subHovered = false;
  },
  
  // Check if the nav or its megamenu is hovered
  isNavHovered(navId) {
    return this.activeNav === navId;
  }
});